export default __webpack_public_path__ + "static/media/error.dd6ded1d.png";